import React from 'react';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BaseWidget from "../../components/widgets/base-widget/BaseWidget";

const WELCOME_INFO_STORAGE_KEY = "platform.workbench.welcomeInfo";

type WelcomeInfoType = {
  isFirstVisit: boolean
};

/**
 * Visualizes a welcome message when visiting the workbench for the first time.
 *
 * Determining the first time visit is done by using the local storage.
 *
 * If {@link WELCOME_INFO_STORAGE_KEY} has a value in the local storage, then
 * the component will not render.
 */
class WelcomeInfoRow extends React.Component<any, WelcomeInfoType> {

  constructor(props: any) {
    super(props);

    this.state = {
      isFirstVisit: !localStorage.getItem(WELCOME_INFO_STORAGE_KEY)
    };

    this.dismissWelcomeMessage = this.dismissWelcomeMessage.bind(this);
  }

  dismissWelcomeMessage() {
    this.setState({
      isFirstVisit: false
    });
    localStorage.setItem(WELCOME_INFO_STORAGE_KEY, 'dismissed');
  }

  render() {
    if (!this.state.isFirstVisit) {
      return false;
    }
    // TODO: Update text
    // TODO: update font to rubik
    // TODO: add transition when dismissing
    return (
      <Row>
        <Col>
          <BaseWidget className="WelcomeInfo">
            <Card.Title>
              <h1>Welcome to Ontotext Platform</h1>
            </Card.Title>
            <Card.Text>
              The Ontotext Platform vision, technology, and business are about making sense of
              text
              and data. Letting big knowledge graphs improve the accuracy of text analytics. Using
              text analytics to interlink and enrich knowledge graphs. Allowing knowledge graphs
              to
              enable better search, exploration, classification, and recommendation across diverse
              information spaces.
            </Card.Text>
            <Button variant="primary" onClick={this.dismissWelcomeMessage}>OK</Button>
          </BaseWidget>
        </Col>
      </Row>
    );
  }

}

export default WelcomeInfoRow;
